import React from "react";

function Location({ color = "var(--primary-color", size = "28" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_423_4997)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 3.125C8.20304 3.125 5.125 6.20304 5.125 10C5.125 11.8525 5.95982 13.6117 7.39131 15.4704C8.60088 17.041 10.1491 18.5768 11.8187 20.2329C11.879 20.2927 11.9394 20.3527 12 20.4128C12.0606 20.3527 12.121 20.2927 12.1813 20.2329C13.8509 18.5768 15.3991 17.041 16.6087 15.4704C18.0402 13.6117 18.875 11.8525 18.875 10C18.875 6.20304 15.797 3.125 12 3.125ZM2.875 10C2.875 4.9604 6.9604 0.875 12 0.875C17.0396 0.875 21.125 4.9604 21.125 10C21.125 12.5658 19.9598 14.8066 18.3913 16.8433C17.0814 18.5442 15.4048 20.2062 13.7373 21.8592C13.4222 22.1716 13.1074 22.4836 12.7955 22.7955C12.5845 23.0065 12.2984 23.125 12 23.125C11.7016 23.125 11.4155 23.0065 11.2045 22.7955C10.8926 22.4836 10.5778 22.1715 10.2627 21.8592C8.59518 20.2062 6.9186 18.5442 5.60869 16.8433C4.04018 14.8066 2.875 12.5658 2.875 10ZM12 8.125C10.9645 8.125 10.125 8.96447 10.125 10C10.125 11.0355 10.9645 11.875 12 11.875C13.0355 11.875 13.875 11.0355 13.875 10C13.875 8.96447 13.0355 8.125 12 8.125ZM7.875 10C7.875 7.72183 9.72182 5.875 12 5.875C14.2782 5.875 16.125 7.72183 16.125 10C16.125 12.2782 14.2782 14.125 12 14.125C9.72182 14.125 7.875 12.2782 7.875 10Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_423_4997">
          <rect width={size} height={size} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Location;
